import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { NumberGrid } from '../components/NumberGrid';
import { CurrentTrack } from '../components/CurrentTrack';
import { AudioPlayer } from '../components/AudioPlayer';
import { useSessionSync } from '../hooks/useSessionSync';
import { useTvFullscreen } from '../hooks/useTvFullscreen';
import { useScreenWakeLock } from '../hooks/useScreenWakeLock';
import { useSessionStore } from '../store/sessionStore';
import { clearSavedRole } from '../services/roleStorage';
import './TvPage.css';

/** Экран телевизора: сетка, оверлей и звук. */
export const TvPage = () => {
  useSessionSync('display');
  useScreenWakeLock();
  const { active: fullscreen, available: canFullscreen, toggle: toggleFullscreen } =
    useTvFullscreen();
  const navigate = useNavigate();
  const session = useSessionStore((state) => state.session);
  const total = Object.keys(session.numberToTrackMap).length;
  const allNumbers = Array.from({ length: total }, (_, i) => i + 1);
  const numbers = session.hidePlayed
    ? allNumbers.filter((number) => !session.playedNumbers.includes(number))
    : allNumbers;
  const overlayUp = Boolean(session.currentTrack && session.isPlaying);
  /** Пока оверлей на экране, сетку не перестраиваем. */
  const visibleNumbersRef = useRef(numbers);
  if (!overlayUp) {
    visibleNumbersRef.current = numbers;
  }

  const switchRole = () => {
    clearSavedRole();
    navigate('/');
  };

  return (
    <div className="tv-page">
      <AudioPlayer />
      {session.package ? (
        <NumberGrid
          variant="tv"
          numbers={visibleNumbersRef.current}
          playedNumbers={session.playedNumbers}
        />
      ) : (
        <div className="tv-waiting">
          <p>Ждём пакет с пульта</p>
        </div>
      )}
      <CurrentTrack />
      {canFullscreen && !fullscreen && (
        <button type="button" className="tv-fullscreen" onClick={toggleFullscreen}>
          Полный экран
        </button>
      )}
      <button type="button" className="tv-role-switch" onClick={switchRole}>
        Сменить роль
      </button>
    </div>
  );
};
